import { useEffect } from "react";
import { motion } from "framer-motion";
import Lenis from "lenis";
import "lenis/dist/lenis.css";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 40, className = "", ...rest }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

const LINE = { hidden: { y: "110%" }, show: { y: "0%" } };

export function MaskLine({ children, delay = 0, className = "", inView = false }) {
  const trigger = inView ? { whileInView: "show", viewport: { once: true, amount: 0.5 } } : { animate: "show" };
  return (
    <motion.span initial="hidden" {...trigger} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
      <motion.span variants={LINE} className={`inline-block ${className}`} transition={{ duration: 1.2, delay, ease: EASE }}>
        {children}
      </motion.span>
    </motion.span>
  );
}

export function Chapter({ n, label, dark = false }) {
  return (
    <div className={`flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] ${dark ? "text-white/50" : "text-slate-500"}`}>
      <span className={dark ? "text-blue-400" : "text-blue-600"}>{n}</span>
      <span className={`h-px w-10 ${dark ? "bg-white/20" : "bg-slate-300"}`} />
      {label}
    </div>
  );
}

export function useLenis() {
  useEffect(() => {
    const lenis = new Lenis({
      lerp: 0.085,
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 1.6,
      syncTouch: false,
    });
    let id;
    const raf = (t) => {
      lenis.raf(t);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    window.__lenis = lenis;
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
}

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
  else el.scrollIntoView({ behavior: "smooth" });
};
